/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as React from 'react';
import ReactDOM from 'react-dom';
import { ECOMVariation } from './ECOMVariation';
import { useIsMobile } from '../../hoc/hooks';

export const productPricingRoot = document.getElementById(
    'react-product--pricing'
);
export const productPricingMobileRoot = document.getElementById(
    'react-product--pricing-mobile'
);

function ProductPricing({ obsolete, obsoleteText, variations, productCategoryTag }) {
    const isMobile = useIsMobile('999px');

    if (!productPricingRoot || !variations) {
        return null;
    }

    return ReactDOM.createPortal(
        <div
            className={`thumbnail product-page__pricing ${
                obsolete ? ' product-page__pricing--obsolete p-padding-lg' : ''
            }`}
        >
            {!obsolete ? (
                <ECOMVariation variations={variations} obsolete={obsolete} productCategoryTag={productCategoryTag} />
            ) : (
                obsoleteText
            )}
        </div>,
        isMobile ? productPricingMobileRoot : productPricingRoot
    );
}

export default ProductPricing;
